import { Box, Typography, Paper } from '@mui/material';

/** Placeholder until Telegram bot teacher UI exists. */
export default function TeacherBotTelegram() {
  return (
    <Box sx={{ p: 3, maxWidth: 720 }}>
      <Typography variant="h5" gutterBottom>
        Telegram bot
      </Typography>
      <Paper sx={{ p: 2 }}>
        <Typography color="text.secondary">
          Telegram configuration UI is not available yet. Use existing Telegram
          bot settings where already provided.
        </Typography>
      </Paper>
    </Box>
  );
}
